var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Buscador por id venta")]),_c('v-btn',{on:{"click":_vm.getSale}},[_vm._v("simulate search ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }